import { Image, useMantineTheme } from '@mantine/core';

interface WorkspaceLogoProps {
	logo: string;
	size?: number;
	radius?: number;
}

export function WorkspaceLogo({
	logo,
	size = 36,
	radius = 4,
}: WorkspaceLogoProps) {
	const theme = useMantineTheme();
	return (
		<Image
			src={logo}
			mih={size}
			miw={size}
			height={size}
			width={size}
			radius={radius}
			fit="contain"
		/>
	);
}
